import veroLogo from "../assets/vero-logo.avif";

export const BRAND_NAME = "VERO";
export const BRAND_ORANGE = "#802D0A";

export function Brand({ size = "sm" }: { size?: "sm" | "lg" }) {
  const lg = size === "lg";
  return (
    <span
      className="flex min-w-0 items-center"
      aria-label={BRAND_NAME}
      title={BRAND_NAME}
    >
      <img
        src={veroLogo}
        alt={BRAND_NAME}
        className="w-auto shrink-0"
        style={{ height: lg ? 52 : 36 }}
        draggable={false}
      />
    </span>
  );
}
